export function tariffsTabs() {
    const tabsNavItems = document.querySelectorAll('.js-tabs-btn');
    const tabsContentItems = document.querySelectorAll('.tabs__content');

    tabsNavItems.forEach(function (tabsItem) {
        tabsItem.addEventListener('click', function showTab(e) {
            const path = e.currentTarget.dataset.path;
            tabsNavItems.forEach((el) => {
                el.classList.remove('active-tab');
            });
            tabsContentItems.forEach(function (tabsItem) {
                tabsItem.classList.remove('active-content-tab');
            });
            document.querySelector(`[data-target="${path}"]`).classList.add('active-content-tab');
            document.querySelector(`.tabs__navigation-btn[data-path="${path}"]`).classList.add('active-tab');
        });
    });
}
